import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Învelește un tabel ca să scroll-eze ORIZONTAL pe ecrane înguste în loc să taie
 * coloane. `minWidth` garantează că nicio coloană nu e comprimată ilizibil.
 */
export function TableScroll({
  children,
  minWidth = "40rem",
}: {
  children: ReactNode;
  minWidth?: string;
}) {
  return (
    <div className="-mx-1 overflow-x-auto px-1 scrollbar-thin">
      <div className={cn("min-w-full")} style={{ minWidth }}>
        {children}
      </div>
    </div>
  );
}
